import { Theme, useMediaQuery, useTheme } from '@mui/material';
import { Breakpoint } from '@mui/material/styles';

export const mobileBreakpoint = 'sm';
export const useIsMobile = (breakpoint: Breakpoint = 'md') => {
  const theme = useTheme();

  return useMediaQuery<Theme>(theme.breakpoints.down(breakpoint), { noSsr: true });
};

export const useDownBreakpoint = (breakpoint: Breakpoint) => {
  const theme = useTheme();

  return useMediaQuery<Theme>(theme.breakpoints.down(breakpoint), { noSsr: true });
};


export const useUpBreakpoint = (breakpoint: Breakpoint) => {
  const theme = useTheme();

  return useMediaQuery<Theme>(theme.breakpoints.up(breakpoint), { noSsr: true });
};
